import styled from 'styled-components';
import { TrimCarouselStyled } from '../TrimCarouselStyled';
import media from '../../../styles/media';
import { rem } from 'polished';

export const TrimCarouselStyledOV = styled(TrimCarouselStyled)`
    .trimItemWrap {
        box-sizing: border-box;
        border: 1px solid ${({ theme }) => theme.colors.grey20};

        & > div {
            padding: ${rem('20px')};
        }
        &.benefits {
            .generalInfoContainer {
                max-height: initial;
            }

            &.monthlyPrices .priceBox > div:first-child {
                min-height: initial;
            }
        }
    }

    .currentSlideSection {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
        font-size: ${rem('20px')};
        position: absolute;
        width: fit-content;
        left: 0;
        right: 0;
        top: ${rem('5px')};
        margin-left: auto;
        margin-right: auto;
    }

    .carouselArrows-wrapper {
        position: absolute;
        top: 0;
        text-align: right;
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0 ${rem('10px')};

        ${media.lg`
            width: 100%;
            left: 0;
            padding: 0;
        `}

        &__btnsSection {
            .arrowBtn {
                background-color: ${({ theme }) => theme.colors.primary};

                .icon-wrapper {
                    svg {
                        path {
                            stroke: ${({ theme }) => theme.colors.black};
                        }
                    }
                }

                &--disabled {
                    pointer-events: none;
                    background-color: ${({ theme }) => theme.colors.grey4};
                    .icon-wrapper {
                        svg {
                            path {
                                stroke: ${({ theme }) => theme.colors.white};
                            }
                        }
                    }
                }
            }
        }
    }
`;
